export const NO_ORGANIZATION_GROUP_VALUE = 'NO_ORGANIZATION_GROUP';

export const getGroupSelectValue = (groupId?: string | null) => groupId || NO_ORGANIZATION_GROUP_VALUE;

export const getGroupPayloadValue = (value: string) => (value === NO_ORGANIZATION_GROUP_VALUE ? null : value);
